import React from 'react';
import '../styles/MapComponent.css';
import MapComponent2 from '../components/MapComponent2';
import WhatsappCTA from '../components/WhatsappCTA';

const Map = ({language}) => {

    return (
        <div className="map">
            <MapComponent2 language={language} />

            <WhatsappCTA language={language}/>

        </div>
    );
  };
  
  export default Map;